import { render } from "./correoPorDefecto.vue?vue&type=template&id=2f137c13"
import script from "./correoPorDefecto.vue?vue&type=script&lang=js"
export * from "./correoPorDefecto.vue?vue&type=script&lang=js"

import "./correoPorDefecto.vue?vue&type=style&index=0&id=2f137c13&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__